import React, { useEffect } from 'react';

import { useNotifications } from './useNotification';

const Notification = ({ navigate }) => {

    const { notification, setNotification } = useNotifications() || [];

    useEffect(() => {
        if (notification) {
            console.log(notification);
        }
    }, [notification]);

    const goToNotificationPage = () => {
        navigate('/notifications');
    }



    return (
        <div className="relative group">
            {/* Notifications Bell Icon */}
            <button className="focus:outline-none">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6 text-gray-500 cursor-pointer"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6 6 0 10-12 0v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                    />
                </svg>
            </button>
            {notification.length > 0 && (
                <span className="absolute top-0 right-0 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-red-100 bg-red-600 rounded-full transform translate-x-1/2 -translate-y-1/2">
                    {notification.length}
                </span>
            )}
            <div className="absolute right-0 w-64 bg-white border border-gray-200 rounded-md shadow-lg overflow-hidden z-20 hidden group-hover:block">
                <div className="py-2">

                    {notification.map((notif, index) => (
                        <div key={index} className="px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer border-b border-gray-200 flex justify-between items-center">
                            <span>{notif.message}</span>
                            <button
                                onClick={() => setNotification((prev) => prev.filter((_, i) => i !== index))}
                                className="text-red-500 hover:text-red-700"
                            >
                                Mark Read
                            </button>
                        </div>
                    ))}
                    {notification.length === 0 && (
                        <div className="px-4 py-2 text-sm text-gray-700">
                            No new notifications
                        </div>
                    )}
                </div>
                <div>
                    <div className="px-4 py-2 text-sm text-blue-500 hover:bg-gray-100 cursor-pointer" onClick={goToNotificationPage}>
                        View All
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Notification;